import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useShop } from "@/context/Shop";
import { errMsg } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";

export default function AccountLogin() {
  const { login, customer } = useShop();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();
  useSeo("Sign in");
  if (customer) {
    navigate("/account", { replace: true });
    return null;
  }
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate(loc.state?.from || "/account", { replace: true });
    } catch (err) {
      toast.error(errMsg(err, "Incorrect email or password"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="container-lux py-16 lg:py-24" data-testid="account-login-page">
      <div className="max-w-md mx-auto">
        <h1 className="font-display text-5xl font-medium text-center">Welcome back</h1>
        <p className="text-sm text-muted-foreground text-center mt-3">Sign in to view your orders, saved pieces and preferences.</p>
        <form onSubmit={submit} className="mt-10 space-y-5 bg-white border rounded-lg p-6 lg:p-8" data-testid="account-login-form">
          <div><Label htmlFor="login-email">Email address</Label><Input id="login-email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" /></div>
          <div><Label htmlFor="login-password">Password</Label><Input id="login-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" /></div>
          <button type="submit" disabled={busy || !email || !password} className="btn-ink w-full" data-testid="login-submit-button">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
        <p className="text-sm text-center mt-8">New to Maison Éclat? <Link to="/account/register" className="link-lux text-foreground font-semibold" data-testid="login-create-link">Create an account</Link></p>
      </div>
    </div>
  );
}
